import { render } from "./PopupHint.vue?vue&type=template&id=bf94fc7e"
import script from "./PopupHint.vue?vue&type=script&lang=js"
export * from "./PopupHint.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__